import { FC } from 'react';

import { useRebrand } from '@growtherapy/sprout-ui';

import {
  BackgroundAnimationOverlay,
  BackgroundAnimationOverlayProps,
} from '../../../components/BackgroundAnimationOverlay';
import { ActionType } from './types';

export type BackgroundAnimationContainerProps = {
  animationStateToggleButtonComponent: FC<{ className?: string }>;
  backgroundAnimationOverlayComponent?: FC<BackgroundAnimationOverlayProps>;
  currentAnimationState: ActionType;
} & BackgroundAnimationOverlayProps;

export function BackgroundAnimationContainer({
  animationStateToggleButtonComponent: AnimationStateToggleButtonComponent,
  backgroundAnimationOverlayComponent: BackgroundAnimationOverlayComponent = BackgroundAnimationOverlay,
  children,
  currentAnimationState,
  ...overlayProps
}: BackgroundAnimationContainerProps) {
  const isRebrand = useRebrand();

  return (
    <>
      {!isRebrand && (
        <BackgroundAnimationOverlayComponent
          {...overlayProps}
          autoplay={currentAnimationState === ActionType.PLAY}
          data-animation-state={currentAnimationState}
        />
      )}
      {/* "relative" to ensure the content is rendered above the animation */}
      <div className='relative flex flex-col overflow-y-auto h-full w-[calc(100%+0.2rem)]'>
        {children}
        {!isRebrand && <AnimationStateToggleButtonComponent className='self-center sm:self-end mx-3 mb-3' />}
      </div>
    </>
  );
}
